import * as React from "react";
function SvgIcTableColumnTime(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 3h20v4H2V3zm1 1v2h18V4H3zM2 8h7v4H2V8zm1 1v2h5V9H3zm-1 4h7v4H2v-4zm1 1v2h5v-2H3zm-1 4h7v4H2v-4zm1 1v2h5v-2H3zm11.636-8h-1.04v.556H12V21h10v-9.444h-1.628V11h-1.04v.556h-4.696V11zm-1.597 2.772v-1.198h7.918v1.198H13.04zM13 20v-5h8v5h-8z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcTableColumnTime;
